"use strict";
/*
 * Created on 1. 4. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../../core/utils/ObjectUtils");
/**
 * Product site key. You can use it for both internal and external ids according to context of usage.
 * @author Radek Beran
 */


var ProductSiteKey =
/*#__PURE__*/
function () {
  function ProductSiteKey(productId, siteId) {
    _classCallCheck(this, ProductSiteKey);

    this.productId = productId;
    this.siteId = siteId;
  }

  _createClass(ProductSiteKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductSiteKey) {
        var otherKey = other;
        return this.productId === otherKey.productId && this.siteId === otherKey.siteId;
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.productId + '-' + this.siteId);
    }
  }]);

  return ProductSiteKey;
}();

exports.ProductSiteKey = ProductSiteKey;